/**
 * Format an Iraqi phone number as "+964 7xx xxx xxxx".
 * Works with:
 *   964XXXXXXXXXX  (country code, no +)
 *   +964XXXXXXXXXX
 *   07XXXXXXXXX    (local 0-prefix, 11 digits)
 * Returns raw unchanged if pattern doesn't match — never mangles unknown formats.
 */
export function formatIraqPhone(raw: string | null | undefined): string {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');

  let national: string | null = null;

  if (digits.startsWith('964') && digits.length === 13) {
    national = digits.slice(3);
  } else if (digits.startsWith('0') && digits.length === 11) {
    national = digits.slice(1);
  } else if (digits.length === 10 && digits.startsWith('7')) {
    national = digits;
  }

  if (national && national.length === 10 && national.startsWith('7')) {
    return `+964 ${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
  }

  return raw;
}
